import { CUSTOMER_JOURNEY_LOGIN_RESERVATION } from '../const';

function action(checkInDate, checkOutDate, surname, token, lang, successCallback, errorCallback, context) {
  return { type: CUSTOMER_JOURNEY_LOGIN_RESERVATION, checkInDate, checkOutDate, surname, token, lang, successCallback, errorCallback, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyLoginReservation.js